import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { DeleteUser } from 'types/api'

export function useDeleteAccount(id: string) {
  const toast = useToast()
  const onError = useOnError()
  const { t } = useTranslation('settings')

  async function deleteAccount(args: DeleteUser) {
    const res = await apiClient.delete<undefined>(SNA_PREFIX + `users/${id}`, {
      data: args
    })
    return res.data
  }

  return useMutation({
    mutationFn: deleteAccount,
    onSuccess: () => {
      toast.success({ message: t('success.accountDeleted') })

      localStorage.removeItem('user')
      localStorage.removeItem('accessToken')

      window.location.href = '/login'
    },
    onError
  })
}
